import axios from 'axios'

declare global {
  interface Window {
    campaignParams: {
      nedarimGroup?: string
      restUrl: string
      restNonce: string
      mosadId: string
      apiValid: string
      assetsUrl: string
      errorEmail: string
      testMode: boolean
      tiers: Array<{
        monthly_tier: number
        months: number
        label: string
        sublabel?: string
      }>
      sidebarImagesDesktop: string[]
      sidebarImagesMobile: string[]    }
  }
}

const client = axios.create({
  baseURL: window.campaignParams?.restUrl ?? '/wp-json/v1/campaign',
  headers: {
    'Content-Type': 'application/json',
    'X-WP-Nonce': window.campaignParams?.restNonce ?? '',
  },
})

export default client
